const $ = require('jquery')
const Promise = require('bluebird')
const { randstr, url } = require('../utils')
const debounce = require('microsistec/debounce')

const request = require('superagent')
const Mark = require('mark.js')

const template = require('templates/search.hbs')

$.fn.pipelineSearch = function () {
    return $(this).each(function () {
        let currentRequest = null

        const self = $(this)
        const holder = $(this).parents('.pipeline-search-holder')
        const id = `pipeline-search-${randstr()}`

        self.addClass(id)

        const state = {
            'hasResults': false,
            'resultSet': [],
            'loading': true,
            'query': self.val(),
            'focused': false,
            'typing': false,
            'currentLink': 0,
            'hasScroll': false
        }

        if (self.hasClass('booted')) return

        const destroy = function (blur = false) {
            if (holder.has('.pipeline-search-dropdown')) {
                holder.find('.pipeline-search-dropdown').remove()
            }

            if (blur) {
                self.trigger('search:blur')
                self.blur()
            }
        }

        const render = function () {
            if (!state.focused) return

            destroy()

            const dropdown = template(state)
            const $dropdown = $(dropdown)

            $dropdown.find('.pipeline-search-close').click(function () {
                state.focused = false
                destroy()
            })

            holder.append($dropdown)

            if (state.hasResults && !state.typing) {
                $dropdown.find('.highlightable').each((_, $el) => {
                    new Mark($el).unmark().mark(self.val())
                })
            }

            state.hasScroll = false
            if ($dropdown.height() > 400) {
                state.hasScroll = true
                $dropdown.find('.pipeline-search-scroll').slimScroll({
                    height: 500,
                    alwaysVisible: false
                })
            }

            pickLink(state.currentLink)
        }

        self.on('focus', function () {
            state.focused = true
            render()
        })

        const pickLink = (index) => {
            const $links = holder.find('.pipeline-search-link-box')

            if (!$links.length) {
                return
            }

            let $link = null

            if (index < 0) {
                state.currentLink = $links.length - 1
                render()
                return
            } else {
                $link = $links.eq(index)
            }

            if (!$link.length) {
                state.currentLink = 0
                render()
                return
            }

            $link.addClass('pipeline-current-link')

            if (state.hasScroll) {
                const $scroll = holder.find('.pipeline-search-scroll')
                const elPosition = $link.position()

                $scroll.slimScroll({
                    scrollTo: (elPosition.top - 150) + 'px',
                    animate: false
                })
            }
        }

        const prevLink = () => {
            state.currentLink = state.currentLink - 1
            render()
        }

        const nextLink = () => {
            state.currentLink = state.currentLink + 1
            render()
        }

        const clickLink = () => {
            const $links = holder.find('.pipeline-search-link-box')
            const $link = $links.eq(state.currentLink)
            if ($link.length) {
                $link.get(0).click()
                destroy(true)
            }
        }

        // self.on('blur', function () {
        //    setTimeout(function () {
        //        state.focused = false;
        //        destroy();
        //    }, 1000);
        // });

        $(document).click(function (e) {
            if (e.target != self[ 0 ] && !$.contains(holder[ 0 ], e.target)) {
                state.focused = false
                destroy()
            }
        })

        self.on('keydown', function (e) {
            switch (e.which) {
                case 27:
                    state.focused = false
                    destroy(true)
                    break
                case 38:
                    prevLink()
                    e.preventDefault()
                    break
                case 40:
                    nextLink()
                    e.preventDefault()
                    break
                case 13:
                    clickLink()
                    break
            }
        })

        self.on('input', debounce(function (e) {
            if (currentRequest) {
                currentRequest.abort()
            }

            state.query = $(this).val()
            state.resultSet = []
            state.hasResults = false
            state.loading = true
            state.typing = false

            if (!state.query) return render()

            currentRequest = request
                .get(url('search'))
                .query({ search: state.query, only: self.data('only') })
                .end(function (err, response) {
                    if (err) return
                    state.loading = false
                    state.resultSet = response.body.data
                    state.hasResults = state.resultSet.length > 0
                    state.none = state.resultSet.reduce(function (accumulator, item) {
                        return accumulator && item.data.length < 1
                    }, true)
                    state.resultSet = state.resultSet.map(function (item) {
                        item.hasResults = item.data.length > 0
                        item.list_url = null

                        switch (item.alias) {
                            case 'customers':
                                item.list_url = `/customers?search=${state.query}`
                                break
                            case 'properties':
                                item.list_url = '/properties'
                                break
                            case 'teams':
                                item.list_url = '/teams'
                                break
                            case 'events':
                                item.list_url = '/calendar'
                                break
                            case 'users':
                                item.list_url = '/users'
                                break
                        }

                        item.data = item.data.map(function (item) {
                            return item
                        })
                        return item
                    })

                    render()
                })

            render()
        }, 300, false, function () {
            state.typing = true
            render()
        }))

        if (state.query) {
            self.trigger('input')
        }
    })
}

const search = (self = $(document)) => new Promise((resolve, reject) => {
    self.find('.pipeline-search').pipelineSearch()

    resolve()
})

module.exports = search



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/ui/search.js